import { parseISO, isAfter } from 'date-fns'

export const productOption = {
  methods: {
    priceWithDiscounts(option, currentDate = null, isConnectPrice = false) {
      let amount = isConnectPrice ? option.connectPrice : option.price

      if (currentDate && option.prices.length) {
        for (var i = 0; i < option.prices.length; i++) {
          const priceDate = parseISO(option.prices[i].date_from)
          if (isAfter(priceDate, currentDate)) {
            continue
          } else {
            amount = option.prices[i][isConnectPrice ? 'include_above' : 'above']
            break
          }
        }
      }
      if (!option.discounts.length || isConnectPrice) {
        return amount
      }
      const discount = option.discounts.filter(discount => {
        return option.defaultMul >= discount.count
      })[0]
      if (!discount) {
        return amount
      }
      return discount.rate ? amount * discount.rate : discount.amount
    }
  }
}
